import React, { Component as C } from "react"
import PropTypes from "prop-types"
import Overlay from "react-overlays/Overlay"
import classNames from "classnames"

import styles from "./popover.less"

export default class extends C {
  constructor(props) {
    super(props)

    let result = this.calculatePlacemantAndShouldUpdatePosition(props)

    this.state = {
      placement: result.placement != null ? result.placement : this.props.placement,
      smartPlacement:
        result.smartPlacement != null ? result.smartPlacement : this.props.smartPlacement,
      shouldUpdatePosition:
        result.shouldUpdatePosition != null ? result.shouldUpdatePosition : true,
      arrowOffset: 0,
      doRerender: false,
    }

    this.refPopover = null
    this.onClickAway = this.onClickAway.bind(this)
  }

  static propTypes = {
    className: PropTypes.string,
    placement: PropTypes.oneOf(["top", "bottom", "left", "right", "bottom-start", "top-start"]),
    smartPlacement: PropTypes.bool,
    smartPlacementHeight: PropTypes.number, // max height between edge and anchorEl for replace popover to bottom/top
    anchorEl: PropTypes.object,
    container: PropTypes.object,
    children: PropTypes.node,
    onRequestClose: PropTypes.func,
    open: PropTypes.bool,
    isSmartArrowPosition: PropTypes.bool,
    arrowPosition: PropTypes.string,
    arrowOffset: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    minLeft: PropTypes.number,
    leftSide: PropTypes.string,
    hiddenArrow: PropTypes.bool,
    rightSide: PropTypes.string,
  }

  static defaultProps = {
    open: false,
    placement: "bottom",
    smartPlacement: true,
    smartPlacementHeight: 200,
    isSmartArrowPosition: true,
    hiddenArrow: false,
    arrowOffset: "-8px",
  }

  componentWillReceiveProps(nextProps) {
    let result = this.calculatePlacemantAndShouldUpdatePosition(nextProps)

    this.setState({
      shouldUpdatePosition:
        result.shouldUpdatePosition != null
          ? result.shouldUpdatePosition
          : this.state.shouldUpdatePosition,
      placement: result.placement != null ? result.placement : this.state.placement,
      smartPlacement:
        result.smartPlacement != null ? result.smartPlacement : this.state.smartPlacement,
    })
  }

  calculatePlacemantAndShouldUpdatePosition(props) {
    const { open, smartPlacement } = props

    if (!open) {
      return {
        shouldUpdatePosition: null,
        smartPlacement: true,
        placement: null,
      }
    }

    let shouldUpdatePosition = this.calculateShouldUpdatePosition(props)

    if (!shouldUpdatePosition) {
      return {
        shouldUpdatePosition,
        smartPlacement: true,
        placement: null,
      }
    }

    let placement = this.calculatePlacement(props)
    return {
      shouldUpdatePosition,
      smartPlacement,
      placement,
    }
  }

  componentDidMount() {
    this.toggleListeners()

    if (!this.props.open || !this.props.isSmartArrowPosition) {
      return
    }
  }

  componentDidUpdate() {
    this.toggleListeners()
  }

  componentWillUnmount() {
    window.removeEventListener("touchstart", this.onClickAway, true)
    window.removeEventListener("mousedown", this.onClickAway, true)
    this._isListeningActive = false
  }

  toggleListeners() {
    if (this.props.open && !this._isListeningActive) {
      window.addEventListener("touchstart", this.onClickAway, true)
      window.addEventListener("mousedown", this.onClickAway, true)
      this._isListeningActive = true
    }

    if (!this.props.open && this._isListeningActive) {
      window.removeEventListener("touchstart", this.onClickAway, true)
      window.removeEventListener("mousedown", this.onClickAway, true)
      this._isListeningActive = false
    }
  }

  calculateShouldUpdatePosition(props) {
    let { container } = props

    let box = container != null ? container.getBoundingClientRect() : null

    return box != null ? Boolean(box.width || box.height) : true
  }

  // if not enough space for popover replace to bottom/top
  calculatePlacement(nextProps) {
    if (!nextProps.smartPlacement || !nextProps.anchorEl) {
      return this.props.placement
    }

    let containerBounds =
      nextProps.container != null
        ? nextProps.container.getBoundingClientRect()
        : {
            top: 0,
            bottom: window.innerHeight,
          }
    let anchorElBounds = nextProps.anchorEl.getBoundingClientRect()

    let distanceBottom =
      containerBounds.bottom - anchorElBounds.bottom - this.props.smartPlacementHeight
    let distanceTop = anchorElBounds.top - containerBounds.top - this.props.smartPlacementHeight

    if (nextProps.placement === "bottom" && distanceTop >= 0) {
      return distanceBottom < 0 ? "top" : "bottom"
    } else if (nextProps.placement === "top" && distanceBottom >= 0) {
      return distanceTop < 0 ? "bottom" : "top"
    }

    if (nextProps.placement === "bottom-start" && distanceTop >= 0) {
      return distanceBottom < 0 ? "top-start" : "bottom-start"
    } else if (nextProps.placement === "top-start" && distanceBottom >= 0) {
      return distanceTop < 0 ? "bottom-start" : "top-start"
    }
    return this.props.placement
  }

  onClickAway(event) {
    if (event.defaultPrevented || !this.props.open) {
      return
    }

    if (this._wrap && !this._wrap.contains(event.target)) {
      this.props.onRequestClose && this.props.onRequestClose(event)
    }
  }

  _setWrap = (ref) => (this._wrap = ref)

  _setPopoverRef = (ref) => {
    this.refPopover = ref
  }

  render() {
    let {
      open,
      container,
      anchorEl,
      onMouseEnter,
      onMouseLeave,
      hiddenArrow,
      arrowOffset,
      arrowPosition,
    } = this.props

    let { placement } = this.state

    let shouldShowPopover = open && anchorEl && document.body.contains(anchorEl)

    if (!shouldShowPopover) {
      return null
    }

    let className = classNames(styles.popover, this.props.className, styles[placement])

    return (
      <Overlay show={true} container={container} placement={placement} target={anchorEl}>
        {({ props, arrowProps, placement }) => {
          const arrowPlacement = {
            left: "right",
            right: "left",
            top: "bottom",
            bottom: "top",
            "bottom-start": "top",
            "top-start": "bottom",
          }

          return (
            <div ref={this._setWrap}>
              <div
                ref={this._setPopoverRef}
                className={className}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                {...props}>
                {hiddenArrow ? null : (
                  <div
                    className={classNames(styles.arrow, this.props.arrowClassName)}
                    style={{
                      ...arrowProps.style,
                      [arrowPlacement[placement]]: arrowOffset,
                      left: arrowPosition || "auto",
                    }}
                    ref={arrowProps.ref}
                  />
                )}
                <div className={classNames(styles.popoverContent, this.props.contentClassName)}>
                  {this.props.children}
                </div>
              </div>
            </div>
          )
        }}
      </Overlay>
    )
  }
}
